import React from 'react'
import Skeleton from 'react-loading-skeleton'
import './customBills.scss'

export default function CustomBillsList ({
    customBills,
    pageLoading,
}) {
    const formatBillDate = (value) => {
        if (!value) {
            return ''
        }

        const date = new Date(value)

        if (Number.isNaN(date.getTime())) {
            return value
        }

        return new Intl.DateTimeFormat('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
        }).format(date)
    }

    const LoadingContent = () => {
        return pageLoading ? <Skeleton width={180} count={8} className="ml-28 mt-13"/> : ''
    }

    return (
        <>
            <section className="section--table custom_bills section--table">
                <div className={'section__row section__header'}>
                    <div className={'section__cell section__cell--name'}>
                        <span>Bills</span>
                    </div>
                </div>
                <div className={'section__row section__row--main'}>
                    <div className={'section__cell section__cell--name'}>
                        <div className={'title-3 section__title--spaced custom-bills-table'}>
                            <LoadingContent/>
                            {!pageLoading && (
                                <div className="custom-bills-table">
                                    <div className="custom-bills-table__head">
                                        <span className="custom-bills-table__heading">Bill ID</span>
                                        <span className="custom-bills-table__heading">Datetime</span>
                                        <span className="custom-bills-table__heading">Title</span>
                                    </div>

                                    <div className="custom-bills-table__body">
                                    {customBills?.bills?.map((item) => (
                                        <div
                                            key={item.id}
                                            className="custom-bills-table__row"
                                        >
                                            <span className="custom-bills-table__cell">
                                                {item.bill_id}
                                            </span>
                                            <span className="custom-bills-table__cell">
                                                {formatBillDate(item.datetime)}
                                            </span>
                                            <span className="custom-bills-table__cell custom-bills-table__cell--title">
                                                <a
                                                    href={`/bills/${item.id}`}
                                                    className="custom-bills-table__link"
                                                >
                                                    {item.title}
                                                </a>
                                            </span>
                                        </div>
                                    ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </>

    )
}
